<template>
  <div class="c-inputs">
    <Input
      type="number"
      v-model="temp.value[0]"
      :min="0"
      placeholder=""
      :size="size"
      :required="required"
      trim
      @enter="enter"
      @focusout="focusout($event, 0)"
    />
    <span class="c-inputs__hyphen">-</span>
    <Input
      type="number"
      v-model="temp.value[1]"
      :min="0"
      placeholder=""
      :size="size"
      :required="required"
      trim
      @enter="enter"
      @focusout="focusout($event, 1)"
    />
  </div>
</template>

<script>
import Input from '@/components/Input';

export default {
  model: {
    prop: 'value',
    event: 'focusout'
  },
  props: {
    range: {
      type: Array,
      required: false
    },
    required: {
      type: Boolean,
      required: false
    },
    size: {
      type: String,
      required: false
    },
    value: {
      type: Array,
      required: false
    }
  },
  components: {
    Input
  },
  data() {
    return {
      temp: {
        value: this.value.slice()
      }
    };
  },
  watch: {
    value() {
      this.temp.value = this.value.slice();
    }
  },
  methods: {
    enter(e) {
      e.target.blur();
      this.$emit('enter', this.temp.value);
    },
    focusout(e, index) {
      const value = e.target.value;
      this.temp.value.splice(index, 1, value);

      if (this.range) {
        for (let i = 0; i < this.temp.value.length; i++) {
          if (this.temp.value[i] < this.range[0]) {
            this.temp.value[i] = this.range[0];
          }
          if (this.temp.value[i] > this.range[1]) {
            this.temp.value[i] = this.range[1];
          }
        }
      }
      this.$emit('focusout', this.temp.value);
    }
  }
};
</script>
